import { render } from "./service-list.vue?vue&type=template&id=2de132e3"
import script from "./service-list.vue?vue&type=script&lang=js"
export * from "./service-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__